import React from 'react';
import useTranslation from '../../../util/hooks/useTranslation';
import WidgetSettingModal from '../Components/WidgetSettingModal';

const TagStatusSummarySetting = ({ widgetInfo, ...restProps }) => {
    const t = useTranslation('TagStatusSummaryWidget');
    return (
        <WidgetSettingModal
            headerTitle={t('Tag status summary widget setting')}
            widgetInfo={widgetInfo}
            hiddenHeader
            {...restProps}
        />
    );
};

export default TagStatusSummarySetting;
